/**
 * Converts hex CSS custom properties to space-separated RGB format
 * for Tailwind opacity support on iOS 16 (which lacks color-mix()).
 *
 * For each variable, creates a companion `--var-name-rgb` property
 * with value like "49 163 200" so Tailwind can use rgb(var(--var-name-rgb) / <alpha-value>).
 */
const CSS_VARS_REQUIRING_OPACITY = [
  '--general-brand-main',
  '--general-semantic-success',
  '--component-input-text',
  '--component-button-primary-background',
  '--component-tabs-default',
  '--component-page-control',
];

export function initCssColorVars(): void {
  const styles = getComputedStyle(document.documentElement);
  const declarations: string[] = [];
  CSS_VARS_REQUIRING_OPACITY.forEach(prop => {
    const hex = styles.getPropertyValue(prop).trim();
    if (!hex.startsWith('#')) {
      return;
    }
    const h = hex.length === 4
      ? hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3]
      : hex.slice(1);
    declarations.push(`${prop}-rgb: ${parseInt(h.slice(0, 2), 16)} ${parseInt(h.slice(2, 4), 16)} ${parseInt(h.slice(4, 6), 16)}`);
  });
  if (declarations.length) {
    const style = document.createElement('style');
    style.textContent = `:root { ${declarations.join('; ')}; }`;
    document.head.appendChild(style);
  }
}
